function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * cpf-cnpj-validator v1.0.3
 * (c) 2020-present Carvalho, Vinicius Luiz <carvalho.viniciusluiz@gmail.com>
 * Released under the MIT License.
 */
var BLACKLIST = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999', '12345678909'];
var STRICT_STRIP_REGEX = /[.-]/g;
var LOOSE_STRIP_REGEX = /[^\d]/g;

var verifierDigit = function verifierDigit(digits) {
  var numbers = digits.split('').map(function (number) {
    return parseInt(number, 10);
  });
  var modulus = numbers.length + 1;
  var multiplied = numbers.map(function (number, index) {
    return number * (modulus - index);
  });
  var mod = multiplied.reduce(function (buffer, number) {
    return buffer + number;
  }) % 11;
  return mod < 2 ? 0 : 11 - mod;
};

var strip = function strip(number, strict) {
  var regex = strict ? _get__("STRICT_STRIP_REGEX") : _get__("LOOSE_STRIP_REGEX");
  return (number || '').replace(regex, '');
};

var format = function format(number) {
  return _get__("strip")(number).replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
};

var isValid = function isValid(number, strict) {
  var stripped = _get__("strip")(number, strict);

  if (!stripped) {
    return false;
  }

  if (stripped.length !== 11) {
    return false;
  }

  if (_get__("BLACKLIST").includes(stripped)) {
    return false;
  }

  var numbers = stripped.substr(0, 9);
  numbers += _get__("verifierDigit")(numbers);
  numbers += _get__("verifierDigit")(numbers);
  return numbers.substr(-2) === stripped.substr(-2);
};

var generate = function generate(formatted) {
  var numbers = '';

  for (var i = 0; i < 9; i += 1) {
    numbers += Math.floor(Math.random() * 9);
  }

  numbers += _get__("verifierDigit")(numbers);
  numbers += _get__("verifierDigit")(numbers);
  return formatted ? _get__("format")(numbers) : numbers;
};

var cpf = {
  verifierDigit: _get__("verifierDigit"),
  strip: _get__("strip"),
  format: _get__("format"),
  isValid: _get__("isValid"),
  generate: _get__("generate")
};
var BLACKLIST$1 = ['00000000000000', '11111111111111', '22222222222222', '33333333333333', '44444444444444', '55555555555555', '66666666666666', '77777777777777', '88888888888888', '99999999999999'];
var STRICT_STRIP_REGEX$1 = /[-\\/.]/g;
var LOOSE_STRIP_REGEX$1 = /[^\d]/g;

var verifierDigit$1 = function verifierDigit$1(digits) {
  var index = 2;
  var reverse = digits.split('').reduce(function (buffer, number) {
    return [parseInt(number, 10)].concat(buffer);
  }, []);
  var sum = reverse.reduce(function (buffer, number) {
    buffer += number * index;
    index = index === 9 ? 2 : index + 1;
    return buffer;
  }, 0);
  var mod = sum % 11;
  return mod < 2 ? 0 : 11 - mod;
};

var strip$1 = function strip$1(number, strict) {
  var regex = strict ? _get__("STRICT_STRIP_REGEX$1") : _get__("LOOSE_STRIP_REGEX$1");
  return (number || '').replace(regex, '');
};

var format$1 = function format$1(number) {
  return _get__("strip$1")(number).replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
};

var isValid$1 = function isValid$1(number, strict) {
  var stripped = _get__("strip$1")(number, strict);

  if (!stripped) {
    return false;
  }

  if (stripped.length !== 14) {
    return false;
  }

  if (_get__("BLACKLIST$1").includes(stripped)) {
    return false;
  }

  var numbers = stripped.substr(0, 12);
  numbers += _get__("verifierDigit$1")(numbers);
  numbers += _get__("verifierDigit$1")(numbers);
  return numbers.substr(-2) === stripped.substr(-2);
};

var generate$1 = function generate$1(formatted) {
  var numbers = '';

  for (var i = 0; i < 12; i += 1) {
    numbers += Math.floor(Math.random() * 9);
  }

  numbers += _get__("verifierDigit$1")(numbers);
  numbers += _get__("verifierDigit$1")(numbers);
  return formatted ? _get__("format$1")(numbers) : numbers;
};

var cnpj = {
  verifierDigit: _get__("verifierDigit$1"),
  strip: _get__("strip$1"),
  format: _get__("format$1"),
  isValid: _get__("isValid$1"),
  generate: _get__("generate$1")
};

var validator = function validator(joi) {
  return {
    type: 'document',
    base: joi.string(),
    messages: {
      'document.cpf': 'CPF inválido',
      'document.cnpj': 'CNPJ inválido'
    },
    rules: {
      cpf: {
        validate: function validate(value, helpers, args, options) {
          if (!_get__("cpf").isValid(value)) {
            return helpers.error('document.cpf');
          }

          return value;
        }
      },
      cnpj: {
        validate: function validate(value, helpers, args, options) {
          if (!_get__("cnpj").isValid(value)) {
            return helpers.error('document.cnpj');
          }

          return value;
        }
      }
    }
  };
};

export default _get__("validator");
export { cpf, cnpj, validator };

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "STRICT_STRIP_REGEX":
      return STRICT_STRIP_REGEX;

    case "LOOSE_STRIP_REGEX":
      return LOOSE_STRIP_REGEX;

    case "strip":
      return strip;

    case "BLACKLIST":
      return BLACKLIST;

    case "verifierDigit":
      return verifierDigit;

    case "format":
      return format;

    case "isValid":
      return isValid;

    case "generate":
      return generate;

    case "STRICT_STRIP_REGEX$1":
      return STRICT_STRIP_REGEX$1;

    case "LOOSE_STRIP_REGEX$1":
      return LOOSE_STRIP_REGEX$1;

    case "strip$1":
      return strip$1;

    case "BLACKLIST$1":
      return BLACKLIST$1;

    case "verifierDigit$1":
      return verifierDigit$1;

    case "format$1":
      return format$1;

    case "isValid$1":
      return isValid$1;

    case "generate$1":
      return generate$1;

    case "cpf":
      return cpf;

    case "cnpj":
      return cnpj;

    case "validator":
      return validator;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (_typeof(variableName) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)["catch"](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = _typeof(validator);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(validator, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(validator)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

export { _get__ as __get__, _get__ as __GetDependency__, _set__ as __Rewire__, _set__ as __set__, _reset__ as __ResetDependency__, _RewireAPI__ as __RewireAPI__ };